import React, { FC } from "react";
import { Icon, IconProps } from "@clarkinc/zest-design-system";

export type VideoIconProps = {
  iconProps: IconProps;
};

const VideoIcon: FC<VideoIconProps> = ({ iconProps }) => {
  return <Icon name={iconProps.name || "ri-play-fill"} {...iconProps} />;
};

export default VideoIcon;
